export enum endpointNames {
  deviceManagement = 'DeviceManagement',
  userManagement = 'um',
  monitoring = 'Monitoring',
  carCounter = 'CarCounter',
}

export const VERSION = '3.4.4 (20260910)';
